import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

Sentry.init({
  dsn: 'https://8f423aee0131f04bb4a59e05f5b47d97@sentry.backspace.global/6',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1,
  sendDefaultPii: true,
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch(err => console.error(err));
